<template>
  <section class="hbox stretch">
    <div class="content-main">
      <el-table :data="rows" style="width: 100%" max-height="450">
        <el-table-column prop="MerchantName" label="所属商家" :show-overflow-tooltip="true"> </el-table-column>
        <el-table-column prop="BillNumber" width="140px"  label="单据号" > </el-table-column>
        <el-table-column prop="Type"  label="类型" >
          <template slot-scope="scope">
            <span v-if="scope.row.Type==0">增加</span>
            <span v-if="scope.row.Type==1">扣除</span>
          </template>
        </el-table-column>
        <el-table-column prop="Way"  label="途径" > </el-table-column>
        <el-table-column prop="Value"  label="金额" > </el-table-column>
        <el-table-column prop="Balance"  label="操作后余额" > </el-table-column>
        <el-table-column prop="UserAccount"  label="操作员" > </el-table-column>
        <el-table-column prop="OperateTime" width="160px"  label="操作时间" > </el-table-column>
      </el-table>
      <el-pagination
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
        :current-page="serch.pageIndex"
        :page-size="serch.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="serch.totalCount">
      </el-pagination>
    </div>
  </section>
</template>
<script  type='text/ecmascript-6'>
  export default {    
    props:{
      memberId:0
    },
    data (){
      return {
        name:'',
        rows:[],
        serch:{          
          pageIndex:1,
          pagesize:8,
          totalCount:0,
          memberId:0,
          sort:'Id desc',
        }
      }
    },
    components:{          
    },    
    watch:{
      memberId(newV,oldV){
        this.serch.memberId = newV
        this.serch.pageIndex = 1
        this.GetData()
      }
    },
    computed:{
    },
    mounted(){
    },
    methods:{     
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Statistical/MemberValueNote',
          params: that.serch
        }).then(function (resp) {
          that.serch.totalCount = resp.data.totalCount
          that.rows = resp.data.data
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      handleCurrentChange(val) {
        this.serch.pageIndex = val
        this.GetData()
      },
      
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
.map
  width: 100%;
  height: 200px;
</style>